import { Component, OnInit, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-tokens-added',
  templateUrl: './tokens-added.component.html',
  styleUrls: ['./tokens-added.component.scss']
})
export class TokensAddedComponent implements OnInit {
  
  @Input() public amount;
  constructor(
    private activeModal: NgbActiveModal
  ) { }

  ngOnInit() {
  }
  closeDialog() {
    this.activeModal.dismiss();
  }
}
